<template>
  <div class="tournament-dashboard-wrapper">
    <div class="workspace">
      <slot name="workspace"></slot>
    </div>
    <div class="sidebar">
      <slot name="sidebar"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TournamentDashboard"
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.tournament-dashboard-wrapper {
  @include tf-tokens-light;

  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 16px;
  padding: 16px 20px 30px;
  align-items: start;
  /* серый холст: белые карточки и панель на нём читаются как отдельные блоки */
  min-height: calc(100vh - 140px);

  @media screen and (max-width: 1099px) {
    grid-template-columns: 100%;
  }

  .workspace { min-width: 0; }

  .sidebar {
    position: sticky;
    top: 16px;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
    padding: 16px;
    background: var(--tf-bg);
    border: 1px solid var(--tf-border-strong);
    border-radius: var(--tf-radius);
    box-shadow: var(--tf-shadow-md);

    @media screen and (max-width: 1099px) {
      grid-row-start: 1;
      position: static;
      max-height: none;
    }

    & > *:not(:last-child) { margin-bottom: 16px; }
  }
}

body.dark-only .tournament-dashboard-wrapper {
  @include tf-tokens-dark;
}
</style>
